import { token } from '@terra/ui-styled-system';
import type { TabGroupColor } from '../../../store/layoutStore';

export type CanonicalTabGroupColor =
  | 'gray'
  | 'yellow'
  | 'red'
  | 'green'
  | 'blue'
  | 'orange'
  | 'pink'
  | 'purple'
  | 'darkGreen';

export const TAB_GROUP_COLOR_ORDER: CanonicalTabGroupColor[] = [
  'gray',
  'yellow',
  'red',
  'green',
  'blue',
  'orange',
  'pink',
  'purple',
  'darkGreen',
];

const LEGACY_TAB_GROUP_COLOR: Partial<
  Record<TabGroupColor, CanonicalTabGroupColor>
> = {
  crimson: 'pink',
  cyan: 'darkGreen',
};

type GroupColorTokens = {
  picker: string;
  bg: string;
  border: string;
  fg: string;
};

const GROUP_COLOR_TOKENS: Record<CanonicalTabGroupColor, GroupColorTokens> = {
  gray: {
    picker: token('colors.border.neutral.default'),
    bg: token('colors.bg.decorative.gray'),
    border: token('colors.border.decorative.gray'),
    fg: token('colors.fg.decorative.gray'),
  },
  yellow: {
    picker: token('colors.border.neutral.warning'),
    bg: token('colors.bg.decorative.yellow'),
    border: token('colors.border.decorative.yellow'),
    fg: token('colors.fg.decorative.yellow'),
  },
  red: {
    picker: token('colors.border.neutral.error'),
    bg: token('colors.bg.decorative.red'),
    border: token('colors.border.decorative.red'),
    fg: token('colors.fg.decorative.red'),
  },
  green: {
    picker: token('colors.border.neutral.success'),
    bg: token('colors.bg.decorative.green'),
    border: token('colors.border.decorative.green'),
    fg: token('colors.fg.decorative.green'),
  },
  blue: {
    picker: token('colors.border.neutral.info'),
    bg: token('colors.bg.decorative.blue'),
    border: token('colors.border.decorative.blue'),
    fg: token('colors.fg.decorative.blue'),
  },
  orange: {
    picker: token('colors.border.decorative.orange'),
    bg: token('colors.bg.decorative.orange'),
    border: token('colors.border.decorative.orange'),
    fg: token('colors.fg.decorative.orange'),
  },
  pink: {
    picker: token('colors.border.vulnerability.hot'),
    bg: token('colors.bg.decorative.pink'),
    border: token('colors.border.decorative.pink'),
    fg: token('colors.fg.decorative.pink'),
  },
  purple: {
    picker: token('colors.border.status.inProgress'),
    bg: token('colors.bg.decorative.purple'),
    border: token('colors.border.decorative.purple'),
    fg: token('colors.fg.decorative.purple'),
  },
  darkGreen: {
    picker: token('colors.border.decorative.darkGreen'),
    bg: token('colors.bg.decorative.darkGreen'),
    border: token('colors.border.decorative.darkGreen'),
    fg: token('colors.fg.decorative.darkGreen'),
  },
};

export function toCanonicalTabGroupColor(
  color: TabGroupColor,
): CanonicalTabGroupColor {
  return LEGACY_TAB_GROUP_COLOR[color] ?? (color as CanonicalTabGroupColor);
}

export function getGroupPickerFillColor(color: TabGroupColor): string {
  return GROUP_COLOR_TOKENS[toCanonicalTabGroupColor(color)].picker;
}

export function getDecorativeBgColor(color: TabGroupColor): string {
  return GROUP_COLOR_TOKENS[toCanonicalTabGroupColor(color)].bg;
}

export function getDecorativeFgColor(color: TabGroupColor): string {
  return GROUP_COLOR_TOKENS[toCanonicalTabGroupColor(color)].fg;
}

export function getDecorativeBorderColor(color: TabGroupColor): string {
  return GROUP_COLOR_TOKENS[toCanonicalTabGroupColor(color)].border;
}
